import http from "@utils/request";

/**
 * 获取历史图表数据
 * @param {*} start_time 开始时间
 * @param {*} end_time  结束时间
 * @param {*} site_list 站点列表，一般为一个
 * @param {*} medium_id 介质类型
 */
export const getHistoryChart = ( start_time,end_time, site_list,medium_id) => http({
    method: "POST",
    url: "/bigdata/getChartArr",
    data: {
        start_time,
        end_time,
        site_list,
        medium_id,
    }
    // 不显示加载框
    ,unloading:false
})
